<template>
  <div>
    <div class="toggle-type">
    <div class="flex flex--col">
      <p class='flex flex-justify--flex-start heading'>Currency Type</p>
      <div>
        <input class="inline-toggle" :id="'currency_toggle_' + ruleIndex" type="checkbox" v-model='currency' @change="currencyType"/>
        <label class="checkbox-label" :for="'currency_toggle_' + ruleIndex"></label>
      </div>
    </div>
    <div class="flex flex--col">
        <p class='flex flex-justify--flex-start heading'>Event Date</p>
        <div>
          <input class="inline-toggle" :id="'event_date_toggle_' + ruleIndex" type="checkbox" v-model='eventDate' @change="eventDateType"/>
          <label class="checkbox-label" :for="'event_date_toggle_' + ruleIndex"></label>
        </div>
    </div>
    <div class="flex flex--col">
        <p class='flex flex-justify--flex-start heading'>Dimension</p>
        <div>
          <input class="inline-toggle" :id="'dimension_toggle_' + ruleIndex" type="checkbox" v-model='dimension' @change="dimensionType"/>
          <label class="checkbox-label" :for="'dimension_toggle_' + ruleIndex"></label>
        </div>
    </div>
  </div>
    <div class="flex flex--col flex-items--start">
      <span class="heading mar-bottom--sm">Perform the following SOQL query:</span>
      <textarea class="textarea" v-model="data.soql" name="" id="" cols="30" rows="10" @change='check'></textarea>
      <button class="ghost-button" @click='check'>Check </button>
      <b-alert show dismissible class="error" v-if="error">{{error}}</b-alert>
    </div>
  </div>
</template>
<script>
import rulesApi from '@/api/Stitcher/rules.js'

export default {
  components: {
  },
  props: {
    data: {
      type: Object
    },
    ruleIndex: {
      type: Number
    }
  },
  data () {
    return {
      error: '',
      currency: false,
      eventDate: false,
      dimension: false
    }
  },
  mounted () {
    this.eventDate = this.data.event_date
    if (this.data.event_type) {
      this.currency = true
    }
    this.dimension = this.data.evar_dim
  },
  methods: {
    check () {
      if (!this.data.soql) {
        this.errorValid = 'SOQL query is needed'
        this.$emit('validationError')
      } else {
        rulesApi.soqlValid({ 'soql': this.data.soql, 'crm_connection_id': this.data.crm_connection_id })
          .then(response => {
            this.error = 'SOQL query is needed'
            if (response.status === 'Invalid SOQL') {
              this.error = `${response.details.errorCode} ${response.details.message}`
              this.$emit('validationError')
            } if (response.error) {
              this.error = response.error
            } else {
              this.error = `${response.status} Number of Records: ${response.number_of_records}`
              this.$emit('validated')
            }
          })
      }
    },
    currencyType () {
      if (this.currency) {
        this.data.event_type = 'currency'
      } else {
        this.data.event_type = null
      }
    },
    eventDateType () {
      this.data.event_date = this.eventDate
    },
    dimensionType () {
      this.data.evar_dim = this.dimension
    }
  }

}
</script>
